<template>
    <form role="search" class="mt-3 mb-3">
        <div class="input-group">
            <input class="form-control" type="text" aria-label="Buscar trámites, servicios o áreas" v-on:keyup="searchTyping"
                placeholder="Buscar trámites, servicios o áreas" />
            <div class="searchResult" ref="results" v-if="showResults">
                <div class="row text-center" v-if="this.searchValue.length < 3 && this.searchValue.length > 0">
                    <p class="text-ptn-color-gsj-brand">
                        <b>Ingrese mas de 2 caracteres para buscar</b>
                    </p>
                </div>
                <div class="row text-center" v-if="this.noResults">
                    <p class="text-ptn-color-gsj-brand">
                        <b>Ups! No se encontraron resultados.</b>
                        <br>
                        Intenta buscar con otros términos.
                    </p>
                </div>
                <div class="row" v-if="!this.noResults && this.searchValue.length >=3">
                    <div class="col-md-4 searchCategory">
                        <div class="h6 text-ptn-color-gsj-brand">
                            Categorías:
                        </div>
                        <div class="searchOverFlow searchOverFlow2">
                            <ul class="list-group">
                                <li class="btn-light list-group-item justify-content-between align-items-center liner"
                                    v-for="(el,n) in this.categories" v-bind:key="n">
                                    {{ el.title }}
                                    <div class="text-right">
                                    <span class="badge text-bg-ptn-color-gsj-brand">{{ el.count }} Resultados</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-8 searchList">
                        <div class="h6 text-ptn-color-gsj-brand">
                            Resultados:
                        </div>
                        <div class="searchOverFlow">
                            <ul class="list-group">
                                <li class="card card-body mb-2 liner" v-for="(el,n) in this.items" v-bind:key="n">
                                    <a v-bind:href="el.url" style="text-decoration: none;" v-bind:aria-label="el.title">
                                        <div class="card-title text-ptn-color-gsj-brand">
                                            <b>{{ el.title }}</b>
                                        </div>
                                        <div class="card-text" style="color:black">
                                            {{ el.description }}
                                        </div>
                                    </a>
                                    <div v-on:click="changeCategory(el.category)">
                                        <div class="text-ptn-color-gsj-2">
                                            #{{ el.category }}
                                        </div>
                                    </div>
                                    
                                </li>
                            </ul>
                        </div>
                        <div class="searchPaginate" v-if="this.showPaginate">
                            {{ pageBlock }}
                            <ul class="pagination pagination-sm m-0 text-center">
                                <li class="page-item" v-on:click="changePage(1)" v-if="this.currentPage > 5"><a class="page-link"><b>{{ "<<" }}</b></a></li>
                                <li class="page-item" v-on:click="changePage(currentPage-1)" v-if="this.currentPage > 1"><a class="page-link"><b>{{ "<" }}</b></a></li>

                                <li class="page-item" 
                                v-for="n in (this.totalPages > 5 ? this.showingPages : this.totalPages)" 
                                v-bind:key="n"                                
                                v-bind:class="[ this.currentPage == (n + pageBlock) ? 'active': '']" 
                                v-on:click="changePage((n + pageBlock))"                                
                                data-page="{{ (n + pageBlock) }}">
                                    <a class="page-link">{{ (n + pageBlock) }}</a>
                                </li>

                                <li class="page-item" v-on:click="changePage(currentPage + 1)" v-if="this.totalPages != this.currentPage"><a class="page-link"><b>></b></a></li>
                                <li class="page-item" v-on:click="changePage(totalPages)" v-if="this.totalPages > 5 && currentPage != this.totalPages && (pageBlock + 5) < totalPages"><a class="page-link"><b>>></b></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-group-append">
                <button class="btn btn-secondary" v-on:click="searchClick" aria-label="Buscar" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                        class="bi bi-search" viewBox="0 0 16 16">
                        <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z">
                        </path>
                    </svg>
                    <span class="d-none"> Buscar</span>
                </button>
            </div>
        </div>
    </form>
</template>



<script>
const axios = require("axios");
export default {
    name: 'HeaderSearch',
    props: {
        perPage: Number,
        urlBusqueda : String,
    },
    data() {
        return {
            showResults: false,
            results : 15,
            items : null,
            categories : null,
            showPaginate : false,
            currentPage : 1,
            totalPages : 1,
            searchValue : '',
            showingPages : 5,
            pageBlock : 0,
            noResults : false,
            filterCategory : null,
            apiUrl : process.env.VUE_APP_API_URL + "/search",
        };
    },
    mounted() {
        if(this.perPage){
            this.results = this.perPage;
        }
        if(this.urlBusqueda){
            this.apiUrl = this.urlBusqueda;
        }
    },
    methods: {
        searchClick: function () {
            this.showResults = !this.showResults;
        },
        search : function () {
            var url = this.apiUrl + "?limit=" + this.results +"&q=" + this.searchValue;
            if(this.currentPage > 1){
                url += "&skip=" + (this.results * (this.currentPage - 1))
            }
            if(this.filterCategory != null){
                url += "&category=" + this.filterCategory;
            }
            axios.get(url)
            .then(response => {                
                this.showResults = true;
                if(response.data && response.data.items){
                    this.items = response.data.items;
                    if(this.items.length < 1){
                        this.noResults = true;
                    }else{
                        this.noResults = false;
                    }
                    var categorias = {}
                    if(response.data.categories){
                        this.categories = response.data.categories;
                    }else{
                        response.data.items.forEach(element => {
                            if(categorias[element.category] != undefined){
                                categorias[element.category] = categorias[element.category] + 1;
                            }else{
                                categorias[element.category] = 1;
                            }
                        });
                        categorias = Object.entries(categorias);
                        this.categories = [];
                        categorias.forEach(el => {
                            this.categories.push({
                                title : el[0],
                                count : el[1]
                            })
                        });
                    }
                    if(response.data.limit != response.data.total_items){
                        this.totalPages = parseInt(Math.ceil(response.data.total_items / this.results));
                        this.pageBlock = 0;
                        if(this.totalPages > 5){
                            this.showingPages = 5;
                            if(this.currentPage > 5){
                                this.pageBlock = parseInt(this.totalPages/this.currentPage) * 5;                                
                                if((this.pageBlock + 5) > this.totalPages){
                                    this.showingPages = this.totalPages - (this.pageBlock);
                                }
                            }
                        }                        
                        this.showPaginate = true;  
                    }else{
                        this.showPaginate = false;
                    }
                }else{
                    this.noResults = true;
                }                
            })
            this.$refs.results.scrollIntoView({ behavior: "smooth", block: "center" })
        },
        searchTyping : function(event){
            this.searchValue = event.target.value;
            this.showResults = false;
            this.noResults = false;
            this.currentPage = 1;
            this.filterCategory = null;
            if(this.searchValue.length >= 3){
                this.search();
            }else{
                this.showResults = true;
                this.noResults = false;
            }
        },
        changePage : function(page){
            this.currentPage = page;
            this.search();
        },
        changeCategory : function(categoryId){
            this.currentPage = 1;
            this.filterCategory = categoryId;
            this.search();
        }
    }
}
</script>